import { useContext } from "react";
import { BookProgressContext } from "./BookProgress.context";

/**
 * @description Hook para utilizar o contexto de BookProgress
 * @returns 
 */
export default function useBookProgress() {
    return useContext(BookProgressContext);
}